import React from "react";
import { LayoutGamesMainWebView } from "@/components/webview/games/layout/LayoutGamesMainWebView";
import MetaQuestLazySectionsWebView from "@/components/webview/games/main/MetaQuestLazySectionsWebView";
import GamesBannerWebView from "@/components/webview/games/core/GamesBannerWebView";
import { Button } from "@/v2-components/ui/button";
import { Button2 } from "@/components/webview/games/typograpy/typograpy-webview";
import { useTrans } from "@/utils/useTrans";
import { GamesWrapLazyContentsWebView } from "@/components/webview/games/GamesWrapLazyContentsWebView";
import { openBrowserWebView } from "@/components/webview/utils/webViewBridge";

export const MetaQuestWebView = () => {
  const { t } = useTrans(["games"]);

  return (
    <LayoutGamesMainWebView
      bannerImg={"/images/games/banners/meta-quest-mobile@3x.jpg"}
      bannerContents={
        <>
          <GamesBannerWebView.Title
            text={t(`Wireless Haptics for the Ultimate Quest Experience`)}
          />
          <GamesBannerWebView.Description
            text={t(
              `Enhance your Meta Quest games with real-time full-body haptic feedback—no wires, just pure immersion.`,
            )}
          />
          <div className="mt-6 flex w-full flex-col gap-2 laptop:mt-8 laptop:flex-row">
            <Button
              size="sm"
              variant="darkgray-outline"
              shape="pill"
              className="bg-transparent px-6 laptop:text-blue-60 laptop:outline-blue-60 laptop:hover:bg-blue-60 laptop:hover:text-white"
              onClick={() => {
                openBrowserWebView({
                  url: "support/help/?categorySlug=software-bhaptics-player-for-meta-quest-install-and-set-up",
                });
              }}
            >
              <Button2>{t("Getting Started", { ns: "gnb" })}</Button2>
            </Button>
            <Button
              size="sm"
              variant="darkgray-fill"
              shape="pill"
              className="bg-black px-6 text-white focus-visible:outline-none"
              onClick={() => {
                openBrowserWebView({ url: "games/vr/software/" });
              }}
            >
              <Button2>{t("bHaptics Player for PC")}</Button2>
            </Button>
          </div>
        </>
      }
    >
      {/* lazy 하게 게임컴포넌트를 가져옵니다 */}
      <GamesWrapLazyContentsWebView
        contents={<MetaQuestLazySectionsWebView />}
      />
    </LayoutGamesMainWebView>
  );
};
